import React from 'react';
import { HeadCard } from '../../structure/card/HeadCard';
import { DatatableContadores } from './DatatableContadores';

export const ContadoresPage = () => {
    return (
        <div className="content-wrapper">
            <HeadCard titulo="Contadores" />
            <section className="content">
                <div className="card">
                    <div className="card-header">
                    </div>
                    <DatatableContadores />
                </div>
            </section>
        </div>
    );
};
